import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Alert } from '@zillow/constellation';
import {
  getAreCriminalReportsFrozenSelector,
  getAreEvictionReportsFrozenSelector,
} from '../../../../../../../selectors/sharedReports';
import MessageRachelManager from '../../../../../MessageRachelManager';

function BackgroundCheckSecurityFreezeAlert({ applicant }) {
  const { userId: applicantId } = applicant;
  const areCriminalReportsFrozen = useSelector(getAreCriminalReportsFrozenSelector(applicantId));
  const areEvictionReportsFrozen = useSelector(getAreEvictionReportsFrozenSelector(applicantId));

  let body = null;

  // Both sections are frozen.
  if (areCriminalReportsFrozen && areEvictionReportsFrozen) {
    body =
      `The applicant’s background report is frozen and cannot be viewed at this time. If you require this` +
      ' report, we recommend that you ask the applicant to unfreeze it via CIC customer assistance. Once' +
      ' unfrozen, the report will be viewable within one business day.';

    // Only one section is frozen.
  } else if (areCriminalReportsFrozen || areEvictionReportsFrozen) {
    const recordName = areCriminalReportsFrozen ? 'criminal' : 'housing court';
    body =
      `The applicant’s ${recordName} report is frozen and cannot be viewed at this time. If you require this` +
      ' report, we recommend that you ask the applicant to unfreeze it via CIC customer assistance. Once' +
      ' unfrozen, the report will be viewable within one business day.';
  }

  return body && <Alert appearance="warning" body={body} actionButton={<MessageRachelManager />} />;
}

BackgroundCheckSecurityFreezeAlert.propTypes = {
  applicant: PropTypes.shape({
    userId: PropTypes.string.isRequired,
  }).isRequired,
};

export default BackgroundCheckSecurityFreezeAlert;
